import * as Yup from 'yup';


const extractFileName = (fileName) => {
  return fileName ? fileName.replace(/^\d+-/, "") : "";
};

export const formatFileSize = (size) => {
  if (!size) return "";
  const kbSize = (size / 1024).toFixed(2); // Convert bytes to KB
  return `${kbSize} KB`;
};

export const transformMvocMetaData = (
  mvocMetaData,
  wave_lookup,
  users,
  promptLookup
) => {
  if (!mvocMetaData?.data?.result) return [];
console.log(promptLookup)
console.log(mvocMetaData?.data?.result?.mvoc_insight_metadata_relation)
  return Array.isArray(
    mvocMetaData?.data?.result?.mvoc_insight_metadata_relation
  )
    ? mvocMetaData?.data?.result?.mvoc_insight_metadata_relation?.map(
        (relation) => {
          let mvocDataFileName = null;
          let siFileName = null;
          let createdAt = null;
          let mvocFileSize = null;
          let siFileSize = null;

          relation?.fileMetadata?.forEach((file) => {
            if (file?.file_type === "MVOC") {
              mvocDataFileName =file?.actual_file_name;
              createdAt = file?.created_at;
              mvocFileSize = file?.file_size;
            }
            if (file?.file_type === "SI_MAPPING") {
              siFileName =file?.actual_file_name;
              createdAt = file?.created_at;
              siFileSize = file?.file_size;
            }
          });

          // Find the corresponding key from wave_lookup
          const waveEntry = wave_lookup.find(
            (wave) => wave?.value === relation?.wave
          );
          const waveKey = waveEntry ? waveEntry?.key : "";

          // Find the owner name using user_id
          const ownerEntry = users?.find(
            (user) => user?.user_id === relation?.user_id
          );
          const ownerName = ownerEntry ? ownerEntry?.name : "";

          // Find prompt name and data using prompt_id
          const promptEntry = promptLookup.find(
            (prompt) => prompt?.id === relation?.prompt_id
          );
          console.log(promptEntry)
          const promptName = promptEntry ? promptEntry?.label : "";

          return {
            id: relation?.unified_id,
            mvocFileSize,
            siFileSize,
            unified_id: relation?.unified_id,
            mvocDataFileName,
            siFileName,
            owner: ownerName ? ownerName.charAt(0).toUpperCase() + ownerName.slice(1) : "",
            prompt: promptName,
            wave: waveKey,
            createdAt: createdAt,
            prompt_id: relation?.prompt_id,
          };
        }
      )
    : [];
};






export const createValidationSchema = (ArgUUID) => {
  return Yup.object().shape({
    asset_name: Yup.string().required("Asset name is required"),
    indication_name: Yup.string().required("Indication name is required"),
    manufacturer_name: Yup.string().required("Manufacturer name is required"),
    wave_name: Yup.object()
      .nullable()
      .when([], {
        is: () => !ArgUUID, 
        then: (schema) =>
          schema
            .required("Wave is required")
            .test(
              "is-string-value",
              "Wave must have a valid value",
              (value) => typeof value?.value === "string"
            ),
        otherwise: (schema) => schema.notRequired(),
      }),
    prompt_name: Yup.object()
      .nullable()
      .when([], {
        is: () => !ArgUUID, 
        then: (schema) =>
          schema
            .required("Prompt is required")
            .test(
              "is-string-value",
              "Prompt must have a valid value",
              (value) => typeof value?.value === "string"
            ),
        otherwise: (schema) => schema.notRequired(),
      }),
    attachmentUUID: Yup.string().nullable(), // Include attachmentUUID for reference
  });
};
